/**
 * RESPONSIBILITY: the words around one ministry's own page.
 *
 * A ministry is a ROW, not a section, so the page built from it has nowhere of its own
 * to keep its headings. They are the same on every ministry page — which is what makes
 * one section right and a field per ministry wrong.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

const MISSING = 'When the link is old';

@Section({ name: SectionName.MinistryPage, label: 'Ministries · One ministry page' })
export class MinistryPageSection {
  @Text({ label: 'Events heading', maxLength: 120, default: 'Upcoming', group: 'Its events' })
  upcomingHeading!: string;

  @Text({
    label: 'Events button text', maxLength: 120, default: 'All events', group: 'Its events',
  })
  allEventsLabel!: string;

  @Link({ label: 'Events button link', group: 'Its events', description: LINK_HINT })
  allEventsHref!: string;

  @Text({
    label: 'Title', maxLength: 300, default: 'Want to get involved?', group: 'Invitation',
  })
  involvedHeading!: string;

  @Text({
    label: 'Button text', maxLength: 120, default: 'Contact us', group: 'Invitation',
  })
  involvedCtaLabel!: string;

  @Link({ label: 'Button link', group: 'Invitation', description: LINK_HINT })
  involvedCtaHref!: string;

  @Text({
    label: 'Title', maxLength: 300, default: 'That ministry is not here',
    group: MISSING, collapsed: true,
    description: 'Shown when a link points at a ministry that no longer exists.',
  })
  missingHeading!: string;

  @Paragraph({
    label: 'Text', maxLength: 4000, rows: 2, group: MISSING,
    default: 'It may have been renamed, or the link may be an old one.',
  })
  missingBody!: string;

  @Text({
    label: 'Button text', maxLength: 120, default: 'All ministries', group: MISSING,
  })
  missingCtaLabel!: string;
}
